import { render } from "./Congratulation.vue?vue&type=template&id=3c416b40"
import script from "./Congratulation.vue?vue&type=script&lang=js"
export * from "./Congratulation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__